import { styled, Theme } from '@mui/material/styles'
import MuiTimeline from '@mui/lab/Timeline'
import MuiTimelineOppositeContent from '@mui/lab/TimelineOppositeContent'
import MuiTimelineContent from '@mui/lab/TimelineContent'
import MuiTypography from '@mui/material/Typography'

const headingStyles = (theme: Theme) => ({
  fontSize: theme.typography.pxToRem(15),
  fontWeight: theme.typography.fontWeightRegular,
})

const headingResponsiveStyles = (theme: Theme) => ({
  ...headingStyles(theme),
  '@media (max-width: 740px)': {
    flexDirection: 'column' as const,
    gap: '10px',
  },
})

export const Timeline = styled(MuiTimeline)({
  padding: 0,
})

export const TimelineOppositeContent = styled(MuiTimelineOppositeContent)({
  flex: 'none',
  paddingLeft: 0,
})

export const TimelineContent = styled(MuiTimelineContent)({
  paddingRight: 0,
})

export const AccordionHeadingDiv = styled('div')(({ theme }) =>
  headingStyles(theme)
)

export const AccordionHeadingTypography = styled(MuiTypography)(({ theme }) =>
  headingStyles(theme)
)

export const AccordionHeadingDivResponsive = styled('div')(({ theme }) =>
  headingResponsiveStyles(theme)
)

export const AccordionHeadingTypographyResponsive = styled(MuiTypography)(
  ({ theme }) => headingResponsiveStyles(theme)
)
